import { useEffect, useState } from "react";
import { getCurrentPosition } from "./native/geo";

// Modalità Home: "ai" (Fuma AI) | "mappa" (Mappa Viva) | "smart" (Home Smart)
export const HOME_MODE_KEY = "fuma_home_mode";
const VALID = ["ai", "mappa", "smart"];

export function getGuestHomeMode() {
  const m = localStorage.getItem(HOME_MODE_KEY);
  return VALID.includes(m) ? m : "smart";
}

export function setGuestHomeMode(mode) {
  if (VALID.includes(mode)) localStorage.setItem(HOME_MODE_KEY, mode);
}

// Risolve la modalità effettiva. "auto" (legacy) ricade su "mappa".
export function resolveHomeMode(user) {
  const m = user?.home_mode;
  if (VALID.includes(m)) return m;
  if (m === "auto") return "mappa";
  return getGuestHomeMode();
}

// Semplificazione: la HOME è SEMPRE Fuma AI (nessuna modalità). Mantenute le altre
// funzioni legacy per compatibilità con schermate esistenti.
export function homePath() {
  return "/home";
}

// Distanza in km tra due punti {lat,lng} (haversine).
export function distanceKm(a, b) {
  if (!a || !b || a.lat == null || b.lat == null) return null;
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
}

export function fmtDistance(km) {
  if (km == null) return null;
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`;
}

// Geolocalizzazione (una volta). Web -> navigator.geolocation, Nativo -> GPS via Capacitor.
export function useGeo() {
  const [pos, setPos] = useState(null);
  useEffect(() => {
    let alive = true;
    getCurrentPosition({ timeout: 8000 }).then((p) => { if (alive && p) setPos({ lat: p.lat, lng: p.lng }); });
    return () => { alive = false; };
  }, []);
  return pos;
}
